<app-item class="no-select" [class.rounded-border-box]="showBorderBox" [class.read-only]="readOnly" (click)="clicked()">
    <app-item-label class="validation-label">{{label}}</app-item-label>
    @if (value) {
        <app-svg-icon name="checkbox-outline"></app-svg-icon>
    }
    @else {
        <app-svg-icon name="box-outline"></app-svg-icon>
    }
</app-item>